<template>
    <v-dialog
        v-model="isOpen"
        content-class="v-application v-application--is-ltr group-dialog"
        max-width="580px"
        :fullscreen="!$vuetify.breakpoint.mdAndUp"
    >
        <v-card>
            <v-card-title></v-card-title>
            <v-card-text>
                <template>
                    <v-container
                        class="px-0"
                        fluid
                    >
                        <v-radio-group v-model="mode">
                            <v-radio
                                label="Neue Termingruppe anlegen"
                                id="add_mode_0"
                                :value="0"
                            ></v-radio>
                            <v-radio
                                label="Zu bestehender Termingruppe hinzufügen"
                                id="add_mode_1"
                                :disabled="!safeGroupAppointments.length"
                                :value="1"
                            ></v-radio>
                        </v-radio-group>
                        <v-select
                            v-if="mode === 1"
                            v-model="groupId"
                            :items="groupsOptions"
                            placeholder="Termingruppe"
                            class="select-group"
                        ></v-select>
                    </v-container>
                </template>
            </v-card-text>
            <v-card-actions class="justify-end">
                <v-btn
                    outlined
                    color="secondary"
                    @click="isOpen = false"
                >
                    Abbrechen
                </v-btn>
                <v-btn
                    depressed
                    color="primary"
                    class="save"
                    @click="save"
                    :disabled="mode === 1 && !groupId"
                >
                    speichern
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>


<script>
    export default {
        props: {
            value: Boolean,
            groupAppointments: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                groupId: null,
                mode: 0
            }
        },
        methods: {
            async save() {
                this.$emit('add-group', {
                    mode: this.mode,
                    ...(this.groupId && { groupId: this.groupId })
                });
                this.isOpen = false
            }
        },
        computed: {
            isOpen: {
                get() {
                    return this.value
                },
                set(state) {
                    this.$emit('input', state)
                }
            },
            safeGroupAppointments() {
                return Array.isArray(this.groupAppointments) ? this.groupAppointments : [];
            },
            groupsOptions() {
                return this.safeGroupAppointments.map(group => {
                    const dates = Array.isArray(group.summary?.dates) ? group.summary.dates : [];
                    if (!dates.length) {
                        return {
                            text: `Unbekannte Termine (${group.group_size || 0})`,
                            value: group.group_id
                        }
                    }
                    const firstDate = new Date(dates[0]).toLocaleDateString('de-DE');
                    const lastDate = new Date(dates[dates.length-1]).toLocaleDateString('de-DE');
                    return {
                        text: `${firstDate} - ${lastDate}  (${group.group_size})`,
                        value: group.group_id
                    }
                })
            }
        }
    }
</script>

<style scoped></style>
